export default {
  getdataFinancingList: {
    url: '/data/finance/detail/list',
    method: 'post',
  },
  getFinanceLogList: {
    url: '/data/finance/log/list',
    method: 'post',
  },
  repaymentList: {
    url: '/data/finance/repayment/list',
    method: 'post',
  },
  getVendorNameInfoSelect: {
    url: '/supplier/score/info/list/vendorName',
    method: 'post',
  },
  getApplyNoInfoSelect: {
    url: '/data/finance/detail/list/applyNo',
    method: 'post',
  },
  getScoreList: {
    url: '/supplier/score/info/list',
    method: 'post',
  },
  getInterfaceList: {
    url: '/data/finance/interface/list',
    method: 'post',
  },
  scoreInfoExport: {
    url: '/supplier/score/info/export',
    method: 'post',
    responseType:'blob',
  },
  financeInterfaceExport: {
    url: '/data/finance/interface/export',
    method: 'post',
    responseType:'blob',
  },
  financeDetailExport: {
    url: '/data/finance/detail/export',
    method: 'post',
    responseType:'blob',
  },
  financeInterfaceApply: {
    url: '/data/finance/interface/apply',
    method: 'post',
  },
};
